import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './src/reducers';

//создаём стандартный стор с комбинированными обработчики, начальным состоянием
//для ассинхронности экшенов создаём middleware

export default function configureStore(initialState) {
  return createStore (
    rootReducer,
    initialState,
    applyMiddleware(thunk)
  );
}
